// extracted by mini-css-extract-plugin
export default {"arrows":"index_arrows__MyWbY","box":"index_box__r1RAV","disabled":"index_disabled__W1q53","left":"index_left__rcfHD","right":"index_right__1Cpfk"};